// Convert array of fabric objects to a map with key
export function toMap(key: keyof fabric.Object, objs: fabric.Object[]): Map<string, fabric.Object | undefined> {
  return objs.reduce((map, o) => {
    if (!o[key]) {
      console.error(`PolicyRect: toMap(): object is missing ${key}`);
      console.error(o);
      return map;
    }

    map.set(o[key], o);
    return map;
  }, new Map<string, fabric.Object>());
}
